/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from '../convo/defs.defs'

const $nsid = 'chat.bsky.group.editGroup'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  name: /*#__PURE__*/ l.string({
    maxLength: 500,
    minLength: 1,
    maxGraphemes: 50,
  }),
  convoId: /*#__PURE__*/ l.string(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  convo: /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
    (() => ConvoDefs.convoView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Edits group settings. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'ConvoLocked',
  'InvalidConvo',
  'InsufficientRole',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
